import React from 'react';
import {
  Box, Typography, Button, Alert, Paper, Dialog, DialogTitle,
  DialogContent, DialogActions, IconButton
} from '@mui/material';
import { ContentCopy as CopyIcon } from '@mui/icons-material';

const CredentialsDialog = ({ open, onClose, credentials, onCopy }) => (
  <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
    <DialogTitle sx={{ bgcolor: 'success.main', color: 'white' }}>
      School Created Successfully!
    </DialogTitle>
    <DialogContent sx={{ pt: 3 }}>
      <Alert severity="info" sx={{ mb: 2 }}>
        Save these login credentials! The password won't be shown again.
      </Alert>
      <Paper elevation={0} sx={{ p: 2, bgcolor: 'grey.50', mb: 2 }}>
        <Typography variant="body2" color="text.secondary" gutterBottom>School ID</Typography>
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Typography variant="body1" fontWeight="medium">{credentials.schoolId}</Typography>
          <IconButton size="small" onClick={() => onCopy(credentials.schoolId, 'School ID copied!')}>
            <CopyIcon fontSize="small" />
          </IconButton>
        </Box>
      </Paper>
      <Paper elevation={0} sx={{ p: 2, bgcolor: 'grey.50', mb: 2 }}>
        <Typography variant="body2" color="text.secondary" gutterBottom>Admin Email</Typography>
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Typography variant="body1" fontWeight="medium">{credentials.email}</Typography>
          <IconButton size="small" onClick={() => onCopy(credentials.email, 'Email copied!')}>
            <CopyIcon fontSize="small" />
          </IconButton>
        </Box>
      </Paper>
      <Paper elevation={0} sx={{ p: 2, bgcolor: 'grey.50' }}>
        <Typography variant="body2" color="text.secondary" gutterBottom>Password</Typography>
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Typography variant="h6" fontWeight="bold" color="primary">{credentials.password}</Typography>
          <IconButton size="small" onClick={() => onCopy(credentials.password, 'Password copied!')}>
            <CopyIcon fontSize="small" />
          </IconButton>
        </Box>
      </Paper>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose} variant="contained">Done</Button>
    </DialogActions>
  </Dialog>
);

export default CredentialsDialog;
